import { Controller } from 'stimulus';
import {
  OverlayScrollbars,
} from 'overlayscrollbars';

export default class extends Controller {
  scrollBar = null;

  static targets = ['list'];


  initialize() {
    if (this.hasListTarget) {
      this.initSlider();
    }
  }

  initSlider() {
    OverlayScrollbars({
      target: this.listTarget,
      elements: {
        viewport: this.listTarget.querySelector('.viewport'),
      },
    }, {
      overflow: {
        y: 'hidden',
      }
    });
  }
}
